export default {
	//API_URL: 'http://127.0.0.1:8005/api/',
	 API_URL:'https://ems.myproject.ng/api/',
	//API_URL: 'https://ems-my.herokuapp.com/api/',	
	VERSION: 1
};

